<div class="modal-header">
    <h4 class="modal-title" [innerHTML]="headerTitle"></h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body">
    <ng-form [formGroup]="form">
        <div class="form-group">
            <label for="title">{{ titleLabel }}:</label> <input id="title" class="form-control" formControlName="title" />
        </div>

        <button class="btn btn-info" type="button" [disabled]="!form.valid" (click)="handleSubmit()">{{ 'SUBMIT' | translate }}</button>
    </ng-form>
</div>
